import React from "react";
import Container from "@mui/material/Container";
import { Box, Grid } from "@mui/material";
import "./HeoSection.css";
import devImg from "../../asset/img/programmig.svg";

import Typewriter from "typewriter-effect";
import resume from "../../asset/CV/resume.pdf";
import cv from "../../asset/CV/cv.pdf";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const HeoSection = ({ bd }) => {
  return (
    <Container sx={{ mt: 5 }}>
      <Grid container spacing={2} className="mainContainer">
        <Grid item xs={12} md={5} sx={{ mt: 10 }}>
          <h4 style={{ fontSize: 23 }}>Hello, I'm</h4>
          <h2 style={{ marginTop: 15, fontSize: 40, fontWeight: 700 }}>
            Raton Kumar Das
          </h2>
          <h2>
            <Typewriter
              options={{
                strings: [
                  "Software Developer",
                  "MERN Stack Developer",
                  "Front-End Web Developer",
                  "Angular Developer",
                ],
                autoStart: true,
                loop: true,
              }}
            />
          </h2>
          <Box>
            <a href={resume} download="Raton_Kumar_Das.pdf">
              <button className="resume_btn">Download Resume</button>
            </a>
          </Box>
          <Box>
            <a
              href="https://www.facebook.com/ratonkumar.ratonkumar.1180/"
              className={bd === "dark" ? "aColor" : "aColorb"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon className="socialIcon"></FacebookIcon>
            </a>
            <a
              href="https://github.com/RKD1180"
              className={bd === "dark" ? "aColor" : "aColorb"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <GitHubIcon className="socialIcon"></GitHubIcon>
            </a>
            <a
              href="https://www.linkedin.com/in/raton-kumar-das-650491180/"
              className={bd === "dark" ? "aColor" : "aColorb"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon className="socialIcon"></LinkedInIcon>
            </a>
          </Box>
        </Grid>
        <Grid item xs={12} md={7} className="bgImage">
          <img src={devImg} alt="" />
        </Grid>
      </Grid>
    </Container>
  );
};

export default HeoSection;
